import {useEffect, useState} from "react";
import {API, Endpoints, PageModel, Team} from "@brg/api";
import {ModerationType} from "../../pages/teams/const/ModerationTypes";

const EMPTY_CONTEXTS: string[] = [];

type GetTeamsProps = {
    lang: string;
    contexts?: string[];
    tagIds?: string[];
    moderationTypes?: ModerationType[];
    useTagIdsQuery?: boolean;
    callback?: (n: number) => void;
    disable?: boolean;
    isTagCategory?: boolean;
    category?: string;
    projectFilter?: number;
    page: number;
}

export const useGetTeamsByIds =
    ({lang, contexts = EMPTY_CONTEXTS, tagIds = [] , moderationTypes, useTagIdsQuery = false, callback, disable, projectFilter=0, category, isTagCategory, page = 1 }: GetTeamsProps) => {
        const [resp, setResp] = useState<PageModel<Team>>();
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const offset = 20
        const requestBody = {
            educationTagIds: tagIds,
            moderationTypes: moderationTypes,
            limit: 20,
            offset: (page - 1) * offset
        };

        const tagIdsKey = tagIds.join(',');
        const moderationTypesKey = moderationTypes?.join(',') ?? '';
        const contextsKey = contexts.join(',');

        useEffect(() => {
            if (!disable && tagIds.length && !isTagCategory) {
                setIsLoading(true);
                if (useTagIdsQuery) {
                    let req = API.request()
                        .endpoint(Endpoints.gateway)
                        .url(`/geograffee/api/Team/GetList`)
                        .addQuery('tagIds', tagIds)
                        .addQuery('limit', 20)
                        .addQuery('offset', (page - 1) * offset)
                        .addQuery('page', page);
                    if (moderationTypes?.length) {
                        req = req.addQuery('moderationTypes', moderationTypes);
                    }
                    if (contexts?.length) {
                        req = req.addQuery('contexts', contexts);
                    }
                    req
                        .get()
                        .send()
                        .then((r) => r.json())
                        .then((r: any) => {
                            setIsLoading(false);
                            if (r?.data) {
                                setResp({
                                    ...r,
                                    data: API.toLang(r?.data, lang)
                                });
                                callback && callback(r?.data?.length);
                            }
                        })
                        .catch(() => {
                            setIsLoading(false);
                            setError(true);
                        });
                } else {
                (moderationTypes
                    ? API.request()
                    .endpoint(Endpoints.gateway)
                    .url(`/geograffee/api/Team/GetList`)
                    .addQuery('contexts', contexts)
                    .addQuery('educationTagIds', tagIds)
                    .addQuery('projectFilter', projectFilter)
                    .addQuery('moderationTypes', moderationTypes)
                    : API.request()
                    .endpoint(Endpoints.gateway)
                    .url(`/geograffee/api/Team/GetList`)
                    .addQuery('contexts', contexts))
                    .addQuery('limit', 20)
                    .addQuery('offset', (page - 1) * offset)
                    .addQuery('page', page)
                    .get()
                    .send()
                    .then((r) => r.json())
                    .then((r: any) => {
                        setIsLoading(false);
                        if (r?.data) {
                            setResp({
                                ...r,
                                data: API.toLang(r?.data, lang)
                            })
                            callback && callback(r?.data?.length)
                        }
                    })
                    .catch((e: any) => {
                    setIsLoading(false);
                    setError(true);
                    })
                }
            }
            if (isTagCategory && !disable && tagIds.length){
                setIsLoading(true);
                API.request()
                .post()
                .endpoint(Endpoints.geograffee)
                .url(`/api/Team/GetTeamsList`)
                .body(requestBody)
                .send()
                .then((r) => r.json())
                .then((r: any) => {
                    setIsLoading(false);
                    if (r?.data) {
                        setResp({
                            ...r,
                            data: API.toLang(r?.data, lang)
                        });
                        callback && callback(r?.data?.length);
                    }
                })
                .catch((e: any) => {
                    setIsLoading(false);
                    setError(true);
                });

            }

        }, [lang, disable, callback, tagIdsKey, category, isTagCategory, page, useTagIdsQuery, moderationTypesKey, contextsKey, projectFilter])

        return {resp, isLoading};
}import {useEffect, useState} from "react";
import {API, Endpoints, PageModel, Team} from "@brg/api";
import {ModerationType} from "../../pages/teams/const/ModerationTypes";

const EMPTY_CONTEXTS: string[] = [];

type GetTeamsProps = {
    lang: string;
    contexts?: string[];
    tagIds?: string[];
    moderationTypes?: ModerationType[];
    useTagIdsQuery?: boolean;
    callback?: (n: number) => void;
    disable?: boolean;
    isTagCategory?: boolean;
    category?: string;
    projectFilter?: number;
    page: number;
}

export const useGetTeamsByIds =
    ({lang, contexts = EMPTY_CONTEXTS, tagIds = [] , moderationTypes, useTagIdsQuery = false, callback, disable, projectFilter=0, category, isTagCategory, page = 1 }: GetTeamsProps) => {
        const [resp, setResp] = useState<PageModel<Team>>();
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const offset = 20
        const requestBody = {
            educationTagIds: tagIds,
            moderationTypes: moderationTypes,
            limit: 20,
            offset: (page - 1) * offset
        };

        const tagIdsKey = tagIds.join(',');
        const moderationTypesKey = moderationTypes?.join(',') ?? '';
        const contextsKey = contexts.join(',');

        useEffect(() => {
            if (!disable && tagIds.length && !isTagCategory) {
                setIsLoading(true);
                if (useTagIdsQuery) {
                    let req = API.request()
                        .endpoint(Endpoints.gateway)
                        .url(`/geograffee/api/Team/GetList`)
                        .addQuery('tagIds', tagIds)
                        .addQuery('limit', 20)
                        .addQuery('offset', (page - 1) * offset)
                        .addQuery('page', page);
                    if (moderationTypes?.length) {
                        req = req.addQuery('moderationTypes', moderationTypes);
                    }
                    if (contexts?.length) {
                        req = req.addQuery('contexts', contexts);
                    }
                    req
                        .get()
                        .send()
                        .then((r) => r.json())
                        .then((r: any) => {
                            setIsLoading(false);
                            if (r?.data) {
                                setResp({
                                    ...r,
                                    data: API.toLang(r?.data, lang)
                                });
                                callback && callback(r?.data?.length);
                            }
                        })
                        .catch(() => {
                            setIsLoading(false);
                            setError(true);
                        });
                } else {
                (moderationTypes
                    ? API.request()
                    .endpoint(Endpoints.gateway)
                    .url(`/geograffee/api/Team/GetList`)
                    .addQuery('contexts', contexts)
                    .addQuery('educationTagIds', tagIds)
                    .addQuery('projectFilter', projectFilter)
                    .addQuery('moderationTypes', moderationTypes)
                    : API.request()
                    .endpoint(Endpoints.gateway)
                    .url(`/geograffee/api/Team/GetList`)
                    .addQuery('contexts', contexts))
                    .addQuery('limit', 20)
                    .addQuery('offset', (page - 1) * offset)
                    .addQuery('page', page)
                    .get()
                    .send()
                    .then((r) => r.json())
                    .then((r: any) => {
                        setIsLoading(false);
                        if (r?.data) {
                            setResp({
                                ...r,
                                data: API.toLang(r?.data, lang)
                            })
                            callback && callback(r?.data?.length)
                        }
                    })
                    .catch((e: any) => {
                    setIsLoading(false);
                    setError(true);
                    })
                }
            }
            if (isTagCategory && !disable && tagIds.length){
                setIsLoading(true);
                API.request()
                .post()
                .endpoint(Endpoints.geograffee)
                .url(`/api/Team/GetTeamsList`)
                .body(requestBody)
                .send()
                .then((r) => r.json())
                .then((r: any) => {
                    setIsLoading(false);
                    if (r?.data) {
                        setResp({
                            ...r,
                            data: API.toLang(r?.data, lang)
                        });
                        callback && callback(r?.data?.length);
                    }
                })
                .catch((e: any) => {
                    setIsLoading(false);
                    setError(true);
                });

            }

        }, [lang, disable, callback, tagIdsKey, category, isTagCategory, page, useTagIdsQuery, moderationTypesKey, contextsKey, projectFilter])

        return {resp, isLoading};
}